export class Segments {
  constructor () {
    this.segmentsData = {}
  }

  add (stage, state, demographicValue, size, cluster) {
    let segment = this.getSegment(stage, state, demographicValue)
    this.setSegment(stage, state, demographicValue, {
      size: segment ? segment.size + size : size,
      clusters: cluster ? ((segment && segment.clusters) ? segment.clusters.concat([cluster]) : [cluster]) : undefined
    })
  }

  setSegment (stage, state, demographicValue, segment) {
    const stateSegments = this.segmentsData[stage]
    if (stateSegments) {
      const demographicSegments = this.segmentsData[stage][state]
      if (demographicSegments) {
        const thisSegment = this.segmentsData[stage][state][demographicValue]
        if (thisSegment) {
          Object.assign(thisSegment, segment)
        } else {
          this.segmentsData[stage][state][demographicValue] = segment
        }
      } else {
        this.segmentsData[stage][state] = {
          [demographicValue]: segment
        }
      }
    } else {
      this.segmentsData[stage] = {
        [state]: {
          [demographicValue]: segment
        }
      }
    }
  }

  getSegment (stage, state, demographicValue) {
    return this.segmentsData[stage] && this.segmentsData[stage][state] && this.segmentsData[stage][state][demographicValue]
  }

  getAllSegments () {
    return this.segmentsData
  }

  iterate (iteratorFunction) {
    for (const stage in this.segmentsData) {
      const stateSegmentsInStage = this.segmentsData[stage]

      for (const state in stateSegmentsInStage) {
        const demographicValueSegmentsInState = stateSegmentsInStage[state]

        for (const demographicValue in demographicValueSegmentsInState) {
          const segment = demographicValueSegmentsInState[demographicValue]
          iteratorFunction(segment, stage, state, demographicValue)
        }
      }
    }
  }
}
